import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';

@Injectable({ providedIn: 'root' })
export class NotificationApiService extends BaseApiService {
    async upsertSubscription(
        authId: string,
        endpoint: string,
        p256dh: string,
        auth: string,
    ): Promise<void> {
        const { error } = await this.supabase.rpc('upsert_push_subscription', {
            p_auth_id: authId,
            p_endpoint: endpoint,
            p_p256dh: p256dh,
            p_auth_key: auth,
        });

        if (error) throw error;
    }

    async deleteSubscription(authId: string, endpoint: string): Promise<void> {
        const { error } = await this.supabase.rpc('delete_push_subscription', {
            p_auth_id: authId,
            p_endpoint: endpoint,
        });

        if (error) throw error;
    }
}
